module.exports = __webpack_public_path__ + "assets/place.a5f2313835c34ef7e78d6e842260df81.png";


/*****************
 ** WEBPACK FOOTER
 ** ./img/place.png
 ** module id = 212
 ** module chunks = 0
 **/